// Pure helpers for the scheduled-meetings view (preference 1, design/05). Kept
// DOM-free and unit-tested; the Schedule component renders from these.

export interface Meeting {
  meetingId: number;
  organizerUserId: number;
  caseRef: string | null;
  scheduledStart: string; // ISO 8601
  durationMin: number;
  status: string;
  joinable: boolean;
  participantUserIds: number[];
}

export function sortByStart(meetings: readonly Meeting[]): Meeting[] {
  return [...meetings].sort((a, b) => Date.parse(a.scheduledStart) - Date.parse(b.scheduledStart));
}

export function joinableCount(meetings: readonly Meeting[]): number {
  return meetings.filter((m) => m.joinable).length;
}

/** Deterministic UTC formatting (dd/MM HH:mm) — avoids locale/timezone drift in tests. */
export function formatWhen(iso: string): string {
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getUTCDate())}/${p(d.getUTCMonth() + 1)} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`;
}
